export enum ConnectionStatus {
  OK = 'OK',
  Error = 'Error',
}
